import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import { ArrowSquareOut } from "@phosphor-icons/react";
import React, { useState } from "react";

const Card = ({ icon, title, subTitle, description, link, target, available }) => {
	const [isHover, setIsHover] = useState(false);

	return (
		<a href={link} target={available ? target : "_self"}>
			<Box
				position="relative"
				minW="300px"
				minH="180px"
				borderRadius={8}
				backgroundColor="white"
				boxShadow="0 0 1em #A0AEC0"
				_hover={{ boxShadow: "0 0 1.75em #718096" }}
				transition="0.2s all ease"
				opacity={available ? 1 : 0.7}
				onMouseEnter={() => !available && setIsHover(true)}
				onMouseLeave={() => !available && setIsHover(false)}
			>
				<Box position="absolute" top={4} right={-4} w="50px" h="50px" zIndex={99} hidden={target === ''}>
					<ArrowSquareOut size={28} weight="bold" color="#000" />
				</Box>
				{
					isHover &&
						<Box
							position="absolute"
							display="flex"
							justifyContent="center"
							alignItems="center"
							zIndex={99}
							transition="0.2s all ease"
							w="full"
							h="full"
						>
							<Box
								backgroundColor="white"
								boxShadow="0 0 1em #A0AEC0"
								transition="0.2s all ease"
								p={3}
							>
								<Text fontSize="md" color="black" fontWeight="bold">
									**EM BREVE**
								</Text>
							</Box>
						</Box>
				}
				<Flex w="full" h="full" alignItems="center" px={8} py={4}>
					<Flex h="full" mr={4} alignItems="center">
						{icon}
					</Flex>
					<Flex h="full" justifyContent="start">
						<VStack spacing={4} alignItems="start">
							<Text fontSize="lg" fontWeight="bold" color="black">
								{title.toUpperCase()}
							</Text>
							<Text fontSize="lg" color="black">
								{subTitle.toUpperCase()}
							</Text>
							<Text fontSize="md" color="black">
								{description}
							</Text>
						</VStack>
					</Flex>
				</Flex>
			</Box>
		</a>
	);
};

export default Card;
